export default __webpack_public_path__ + "static/media/foodfriends-mockup-mobile.b7e043d8.png";